import ProfileExpiredCards from "components/profile/ProfileExpiredCards";
import ProfileSound from "components/profile/ProfileSound";
import { useSoundPath } from "hooks/useSoundPath";

const ProfileSettings = () => {

  const playSound = useSoundPath();

  return (
    <main className="profile-content">
      <ul className="profile-content__settings">
        <ProfileExpiredCards playSound={playSound} />
        <ProfileSound playSound={playSound} />
      </ul>
    </main>
  );
};

export default ProfileSettings;
